import ReferalSignup from ".";
import authRoles from "../../utils/auth.roles";
const ReferRoutesSignup = {
  name: 'ReferRoutesSignup',
  auth: authRoles.guest,
  kyc: false,
  mfaNotRequired: true,
  routes: [
    {
      path: "/refer/:referalId",
      component: ReferalSignup,
      exact: true,
    },
  ],
};
export default ReferRoutesSignup;
